import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "sidebar-menu-set" }
const _hoisted_2 = { class: "sidebar-top px-3" }
const _hoisted_3 = { class: "widget s20 text-black p-4 rounded-40 shadow-200 mb-6 px-7 pt-7 pb-6" }
const _hoisted_4 = { class: "flex align-items-center gap-4 mb-3" }
const _hoisted_5 = {
  key: 0,
  class: "tag-state success ml-4"
}
const _hoisted_6 = {
  key: 1,
  class: "tag-state ml-4"
}
const _hoisted_7 = { class: "secondary-font text-primary-color mb-4" }
const _hoisted_8 = { class: "secondary-font" }
const _hoisted_9 = { class: "app-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("aside", {
      class: _normalizeClass(['sidebar', { close: !_ctx.sidebarOpen }])
    }, [
      _createElementVNode("div", {
        class: "sidebar-icon",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
      }, [...(_cache[4] || (_cache[4] = [
        _createElementVNode("div", { class: "barr1" }, null, -1),
        _createElementVNode("div", { class: "barr2" }, null, -1),
        _createElementVNode("div", { class: "barr3" }, null, -1)
      ]))]),
      _createElementVNode("div", {
        class: "sidebar-icon close",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("div", { class: "barr1" }, null, -1),
        _createElementVNode("div", { class: "barr2" }, null, -1),
        _createElementVNode("div", { class: "barr3" }, null, -1)
      ]))]),
      _createElementVNode("ul", _hoisted_1, [
        _createVNode(_component_router_link, { to: "/front/profil" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(['sidebar-menu-animate', { active: _ctx.isActiveRoute('/front/profil') }])
            }, [
              _createElementVNode("li", {
                class: _normalizeClass(['sidebar-menu', { active: _ctx.isActiveRoute('/front/profil') }])
              }, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("img", {
                  src: "/public/icons/icon-profil.svg",
                  class: "sidebar-menu-icon",
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "Mon profil", -1),
                _createElementVNode("div", { class: "my-badge br2 dot bg-color-notif" }, null, -1)
              ]))], 2)
            ], 2)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/front/profil/ma-souscription" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(['sidebar-menu-animate', { active: _ctx.isActiveRoute('/front/profil/ma-souscription') }])
            }, [
              _createElementVNode("li", {
                class: _normalizeClass(['sidebar-menu', { active: _ctx.isActiveRoute('/front/profil/ma-souscription') }])
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("img", {
                  src: "/public/icons/icon-souscription.svg",
                  class: "sidebar-menu-icon",
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "Ma souscription", -1),
                _createElementVNode("div", { class: "my-badge br2 dot bg-color-notif" }, null, -1)
              ]))], 2)
            ], 2)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/front/profil/pouvoir-achat" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(['sidebar-menu-animate', { active: _ctx.isActiveRoute('/front/profil/pouvoir-achat') }])
            }, [
              _createElementVNode("li", {
                class: _normalizeClass(['sidebar-menu', { active: _ctx.isActiveRoute('/front/profil/pouvoir-achat') }])
              }, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("img", {
                  src: "/public/icons/icon-pouvoir.svg",
                  class: "sidebar-menu-icon",
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "Pouvoir d'achat", -1),
                _createElementVNode("div", { class: "my-badge br2 dot bg-color-notif" }, null, -1)
              ]))], 2)
            ], 2)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/front/profil/plan-mensuel" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(['sidebar-menu-animate', { active: _ctx.isActiveRoute('/front/profil/plan-mensuel') }])
            }, [
              _createElementVNode("li", {
                class: _normalizeClass(['sidebar-menu', { active: _ctx.isActiveRoute('/front/profil/plan-mensuel') }])
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("img", {
                  src: "/public/icons/icon-plan.svg",
                  class: "sidebar-menu-icon",
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "Plan mensuel", -1),
                _createElementVNode("div", { class: "my-badge br2 dot bg-color-notif" }, null, -1)
              ]))], 2)
            ], 2)
          ]),
          _: 1
        }),
        _createElementVNode("a", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
          style: {"cursor":"pointer"}
        }, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("div", { class: "sidebar-menu-animate" }, [
            _createElementVNode("li", { class: "sidebar-menu" }, [
              _createElementVNode("img", {
                src: "/public/icons/icon-logout.svg",
                class: "sidebar-menu-icon icon-neutral",
                alt: ""
              }),
              _createElementVNode("span", null, "Déconnexion"),
              _createElementVNode("div", { class: "my-badge br2 dot bg-color-notif" })
            ])
          ], -1)
        ]))]),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "clear-both h-0" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[12] || (_cache[12] = _createElementVNode("img", {
              src: "/public/icons/icon-souscription.svg",
              class: "size-base icon-neutral",
              alt: ""
            }, null, -1)),
            _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "secondary-font" }, "Souscription", -1)),
            (_ctx.souscription?.actif)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Active"))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "Inactive"))
          ]),
          _createElementVNode("h6", _hoisted_7, _toDisplayString(_ctx.souscription ? 'Valable jusqu\'au ' + _ctx.formatDateFrench(_ctx.souscription.date_fin) : '-'), 1),
          _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.userPhone || '-'), 1)
        ])
      ])
    ], 2),
    _createElementVNode("section", _hoisted_9, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "page-space-40" }, null, -1)),
      _createElementVNode("div", {
        class: "sidebar-icon open show-mobile mb-5",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
      }, [...(_cache[14] || (_cache[14] = [
        _createElementVNode("div", { class: "barr1" }, null, -1),
        _createElementVNode("div", { class: "barr2" }, null, -1),
        _createElementVNode("div", { class: "barr3" }, null, -1)
      ]))]),
      _createVNode(_component_router_view)
    ])
  ]))
}